export default { sha: 'd5289ddae4087c9868a10afceee0209cba5e3370', buildNumber: 'undefined' }
